import angular from 'angular'

export default {
  bindings: {
    attribute: '<'
  },
  controller: function() {
    this.equals = angular.equals
    this.display = val => {
      if (angular.isArray(val)) {
        return val.join(', ')
      } else {
        return val
      }
    }
  },
  template: require('./template.html')
}
